var exports = {};
var hasOwnProperty = {}.hasOwnProperty;
var call = Function.prototype.call;
exports = call.bind ? call.bind(hasOwnProperty) : function (O, P) {
  return call.call(hasOwnProperty, O, P);
};
export default exports;